import * as Redux from 'redux';
import { WebPortalClient, Study } from 'webportalclient';


export enum CoreActionType {
    LoadStudies = 'LoadStudies',
    LoadCurrentStudy = 'LoadCurrentStudy',
    LoadSites = 'LoadSites',
    LoadSubjects = 'LoadSubjects',
    LoadVisits = 'LoadVisits',
    LoadStudyVisitSchedule = 'LoadStudyVisitSchedule'
}

export class LoadStudiesAction implements Redux.Action {
    type: CoreActionType.LoadStudies;
    studies: Study[];

    static create(response: Study[]): LoadStudiesAction {
        return {
            type: CoreActionType.LoadStudies,
            studies: response,
        };
    }
}

export class LoadCurrentStudyAction implements Redux.Action {
    type: CoreActionType.LoadCurrentStudy;
    study: Study;

    static create(study: Study): LoadCurrentStudyAction {
        return {
            type: CoreActionType.LoadCurrentStudy,
            study: study,
        };
    }
}

export type CoreAction = LoadStudiesAction | LoadCurrentStudyAction;
